import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';

import {
  CustomAttribute,
  Email,
  Text,
} from 'hb-react/shared/components/formik/components/inputs';

import BoxWrapper from '../BoxWrapper';
import StandardFields from '../StandardFields';
import TicketAddons from '../TicketAddons';

const TicketForm = ({ attendee, event, ticket, index }) => {
  const { customizable_attributes: customizableAttributes } = ticket;
  const { standard_fields: standardFields } = event;

  return (
    <Card bg="white" data-testid="event-ticket-po" mb={5} pt={4} pb={4}>
      <Box font="h3-semibold" mb={3}>
        {__('Ticket %{index} • ').i__({ index: index + 1 })}
        {ticket.name}
      </Box>
      <CardHr />

      <Box
        flexDirection={{ _: 'column', m: 'row' }}
        flexWrap="wrap"
        maxWidth="536px"
      >
        <BoxWrapper>
          <Text
            name={`network_events_booking[attendees_attributes][${index}][firstname]`}
            label={__('First name')}
            validate={{
              required: true,
            }}
          />
        </BoxWrapper>
        <BoxWrapper>
          <Text
            name={`network_events_booking[attendees_attributes][${index}][lastname]`}
            label={__('Last name')}
            validate={{
              required: true,
            }}
          />
        </BoxWrapper>
        <BoxWrapper>
          <Email
            name={`network_events_booking[attendees_attributes][${index}][email]`}
            label={__('Email address')}
            validate={{
              required: true,
            }}
          />
        </BoxWrapper>
        {standardFields && (
          <StandardFields
            fields={standardFields}
            name={`network_events_booking[attendees_attributes][${index}]`}
            Wrapper={BoxWrapper}
          />
        )}

        {customizableAttributes &&
          customizableAttributes.length > 0 &&
          customizableAttributes.map((attribute) => (
            <BoxWrapper
              key={attribute.id}
              $fullWidth={attribute.attribute_type === 'double_select'}
            >
              <CustomAttribute
                name={`network_events_booking[attendees_attributes][${index}][${attribute.name}]`}
                customAttribute={attribute}
                labelMultiline
              />
            </BoxWrapper>
          ))}
      </Box>
      <TicketAddons addons={attendee.addons_attributes} ticketIndex={index} />
    </Card>
  );
};

TicketForm.propTypes = {
  ticket: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    maximum_per_person: PropTypes.number.isRequired,
    customizable_attributes: PropTypes.arrayOf(
      PropTypes.shape({
        attribute_type: PropTypes.string.isRequired,
        customizable_type: PropTypes.string.isRequired,
        display_name: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        multi: PropTypes.bool,
        name: PropTypes.string.isRequired,
        options: PropTypes.array,
        placeholder: PropTypes.string,
        required: PropTypes.bool,
        text_size: PropTypes.number,
        tooltip: PropTypes.string.isRequired,
        visibility: PropTypes.string.isRequired,
      }),
    ),
    addons: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        description: PropTypes.string,
        currency: PropTypes.shape({
          code: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          symbol: PropTypes.string.isRequired,
        }).isRequired,
      }),
    ),
  }).isRequired,
};

export default TicketForm;

const CardHr = styled.hr`
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.space[5]}px;
  border-color: ${({ theme }) => theme.colors.horizon};
`;
